'use client';

/**
 * PaymentLinkBanner
 *
 * Shown on the login page when the user was redirected from a deal payment
 * link (callbackUrl contains "dp=" and "sig="). Explains why they need to
 * log in and what to do if they don't have an account.
 */

import { useSearchParams } from 'next/navigation';

export function PaymentLinkBanner() {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get('callbackUrl') || '';

  const isPaymentLink = callbackUrl.includes('dp=') && callbackUrl.includes('sig=');

  if (!isPaymentLink) return null;

  return (
    <div className="account-alert account-alert--info mb-6" style={{ maxWidth: '100%' }}>
      <p style={{ fontWeight: 600, marginBottom: '4px' }}>
        You have a payment link from your sales representative.
      </p>
      <p>
        Please log in with the email address associated with your account to
        complete your order. If you don&apos;t have an account yet, please
        create one first using the same email your rep has on file, or contact
        your sales representative for assistance.
      </p>
    </div>
  );
}
